
window.TwoLaneFitment = (function () {
  'use strict';

  function slug(v) {
    return String(v == null ? '' : v)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function yearInSpec(spec, year) {
    if (!spec) return false;
    var y = Number(year);
    if (!y) return false;
    var parts = String(spec).split(',');
    for (var i = 0; i < parts.length; i++) {
      var seg = parts[i].split('-');
      var lo = Number(seg[0]);
      var hi = seg.length > 1 ? Number(seg[1]) : lo;
      if (y >= lo && y <= hi) return true;
    }
    return false;
  }

  function offeredMakes() {
    var raw = window.themeSettings && window.themeSettings.fitmentMakes;
    if (!raw) return null;
    var list = (Array.isArray(raw) ? raw : String(raw).split(','))
      .map(function (m) { return String(m).trim(); })
      .filter(Boolean);
    return list.length ? list : null;
  }

  function offeredMake(make) {
    if (!make) return null;
    var list = offeredMakes();
    if (!list) return String(make);
    var want = slug(make);
    for (var i = 0; i < list.length; i++) {
      if (slug(list[i]) === want) return list[i];
    }
    return null;
  }

  function offeredCatalogue(makesMap) {
    if (!makesMap) return makesMap;
    var list = offeredMakes();
    if (!list) return makesMap;
    var wanted = list.map(slug);
    var out = {};
    Object.keys(makesMap).forEach(function (mk) {
      if (wanted.indexOf(slug(mk)) !== -1) out[mk] = makesMap[mk];
    });
    return out;
  }

  function sameModel(tableName, vehicle) {
    if (slug(tableName) === slug(vehicle.model)) return true;
    var all = window.TwoLaneModelKeys;
    if (!all) return false;
    var keys = null;
    for (var mk in all) {
      if (slug(mk) === slug(vehicle.make)) { keys = all[mk]; break; }
    }
    if (!keys) return false;
    var a = keys[vehicle.model];
    var b = keys[tableName];
    if (!a || !b) return false;
    a = a.split('|'); b = b.split('|');
    if (a[2] !== b[2]) return false;
    if (a[1] && b[1] && a[1] !== b[1]) return false;
    var efi = Number(vehicle.year) >= 2007;
    var norm = function (c) { return efi ? c.replace(/-?I2?$/, '') : c; };
    var ca = a[0].split('+').map(norm);
    var cb = b[0].split('+').map(norm);
    for (var i = 0; i < ca.length; i++) {
      if (cb.indexOf(ca[i]) !== -1) return true;
    }
    return false;
  }

  function successorOf(vehicle) {
    var all = window.TwoLaneSuccessors;
    var year = Number(vehicle && vehicle.year);
    if (!all || !year || !vehicle.model) return null;
    for (var mk in all) {
      if (slug(mk) !== slug(vehicle.make)) continue;
      for (var m in all[mk]) {
        if (slug(m) !== slug(vehicle.model)) continue;
        var spec = String(all[mk][m]);
        var cut = spec.indexOf(':');
        var from = Number(spec.slice(0, cut));
        return cut > 0 && from && year >= from ? { from: from, model: spec.slice(cut + 1) } : null;
      }
      return null;
    }
    return null;
  }

  function verdict(record, vehicle, vocab) {
    if (!record || !record.length || !vehicle) return 'unknown';
    var answer = rowsVerdict(record, vehicle, vocab);
    if (answer === 'fits') return answer;
    var next = successorOf(vehicle);
    if (next && rowsVerdict(record, { year: vehicle.year, make: vehicle.make, model: next.model }, vocab) === 'fits') {
      return 'fits';
    }
    return answer;
  }

  function rowsVerdict(record, vehicle, vocab) {
    var wantMake = slug(vehicle.make);
    var wantModel = slug(vehicle.model);
    var year = vehicle.year ? Number(vehicle.year) : null;

    var sawPartial = false;

    for (var i = 0; i < record.length; i++) {
      var group = record[i];
      var groupMake = vocab ? vocab.makes[group[0]] : group[0];
      var spec = group[1];
      var modelIds = group[2] || [];

      if (wantMake && slug(groupMake) !== wantMake) continue;

      var unchecked = false;

      if (year) {
        if (!yearInSpec(spec, year)) continue;
      } else if (String(spec || '').trim() !== '') {
        unchecked = true;
      }

      var matched = false;
      if (!wantModel) {
        matched = true;
        if (modelIds.length) unchecked = true;
      } else {
        for (var j = 0; j < modelIds.length; j++) {
          var name = vocab ? vocab.models[modelIds[j]] : modelIds[j];
          if (sameModel(name, vehicle)) { matched = true; break; }
        }
      }

      if (!matched) continue;

      if (!unchecked) return 'fits';

      sawPartial = true;
    }

    return sawPartial ? 'unknown' : 'no';
  }

  function lastYear(record, make, vocab) {
    if (!record || !record.length) return null;
    var wantMake = slug(make);
    var max = null;
    for (var i = 0; i < record.length; i++) {
      var group = record[i];
      var groupMake = vocab ? vocab.makes[group[0]] : group[0];
      if (wantMake && slug(groupMake) !== wantMake) continue;
      var parts = String(group[1] || '').split(',');
      for (var j = 0; j < parts.length; j++) {
        var seg = parts[j].split('-');
        var hi = Number(seg.length > 1 ? seg[1] : seg[0]);
        if (hi && (max === null || hi > max)) max = hi;
      }
    }
    return max;
  }

  var GENERATIONS = {
    touring: [2009, 2014, 2024],
    softail: [2000, 2018],
    dyna: [2006],
    sportster: [2004, 2007]
  };

  function tableMayPredate(record, vehicle, vocab) {
    var year = Number(vehicle && vehicle.year);
    if (!year) return false;
    var last = lastYear(record, vehicle.make, vocab);
    if (last === null || year <= last || year - last > 2) return false;
    var atLast = { year: String(last), make: vehicle.make, model: vehicle.model };
    if (verdict(record, atLast, vocab) !== 'fits') return false;
    var fam = familyOf(vehicle);
    var breaks = GENERATIONS[fam] || [];
    for (var i = 0; i < breaks.length; i++) {
      if (breaks[i] > last && breaks[i] <= year) return false;
    }
    return true;
  }

  function summary(record, vocab) {
    if (!record || !record.length) return '';
    var makes = [];
    var lo = null;
    var hi = null;
    record.forEach(function (g) {
      var mk = vocab ? vocab.makes[g[0]] : g[0];
      if (!offeredMake(mk)) return;
      if (makes.indexOf(mk) === -1) makes.push(mk);
      String(g[1]).split(',').forEach(function (seg) {
        var p = seg.split('-');
        var a = Number(p[0]);
        var b = p.length > 1 ? Number(p[1]) : a;
        if (lo === null || a < lo) lo = a;
        if (hi === null || b > hi) hi = b;
      });
    });
    var span = lo === null ? '' : (lo === hi ? String(lo) : lo + '-' + hi);
    return (makes.slice(0, 2).join(' / ') + ' ' + span).trim();
  }

  var familySource = null;
  var familyBySlug = null;

  function familyIndex(all) {
    if (all === familySource) return familyBySlug;
    var index = Object.create(null);
    for (var mk in all) {
      var makeKey = slug(mk);
      if (makeKey in index) continue;
      var models = Object.create(null);
      for (var m in all[mk]) {
        var modelKey = slug(m);
        if (!(modelKey in models)) models[modelKey] = all[mk][m];
      }
      index[makeKey] = models;
    }
    familySource = all;
    familyBySlug = index;
    return index;
  }

  function familyOf(vehicle) {
    var all = window.TwoLaneVehicleFamilies;
    if (!all || !vehicle || !vehicle.make || !vehicle.model) return '';
    var byModel = familyIndex(all)[slug(vehicle.make)];
    if (!byModel) return '';
    var spec = byModel[slug(vehicle.model)];
    if (!spec) return '';

    var year = Number(vehicle.year);
    var seen = [];
    var parts = String(spec).split(',');
    for (var i = 0; i < parts.length; i++) {
      var bits = parts[i].split(':');
      var fam = bits[1];
      if (!fam) continue;
      if (seen.indexOf(fam) === -1) seen.push(fam);
      if (year) {
        var range = bits[0].split('-');
        var lo = Number(range[0]);
        var hi = range.length > 1 ? Number(range[1]) : lo;
        if (year >= lo && year <= hi) return fam;
      }
    }
    return !year && seen.length === 1 ? seen[0] : '';
  }

  function familyVerdict(families, family) {
    if (!family || !families || !families.length) return 'unknown';
    return families.indexOf(family) !== -1 ? 'family' : 'no';
  }

  function familyLabel(family) {
    family = String(family || '');
    return family ? family.charAt(0).toUpperCase() + family.slice(1) : '';
  }

  return {
    slug: slug, yearInSpec: yearInSpec, verdict: verdict, summary: summary, lastYear: lastYear,
    tableMayPredate: tableMayPredate, sameModel: sameModel, successorOf: successorOf,
    offeredMakes: offeredMakes, offeredMake: offeredMake, offeredCatalogue: offeredCatalogue,
    familyOf: familyOf, familyVerdict: familyVerdict, familyLabel: familyLabel
  };
})();
